module.exports = __webpack_public_path__ + "img/td_logo.e136362d.png";